import WebFont from 'webfontloader'

// load web fonts
export const loadFonts = (fonts) => {
  WebFont.load({
    google: {
      families: fonts
    }
  })
}
